import { Row } from '@/components/grid/grid-component';
import styled from 'styled-components';

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK} !important;
  margin-bottom: 25px !important;
  padding: 24px !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  justify-content: end !important;
`;

const Main = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  min-height: 100%;
  width: 100%;
  height: max-content;
  padding-top: 24px;
`;

const StyledBlockRow = styled(Row)`
  display: block !important;
`;

const StyledRow = {
  RowStyle,
  StyledBlockRow,
  Main,
};

export default StyledRow;
